import { forwardRef } from 'react';
import styles from './badge.module.css';
import clsx from 'clsx';

export type BadgeProps = React.ComponentPropsWithoutRef<'span'> & {
  max?: boolean | string | number;
  children: React.ReactNode;
} & (
    | { size?: 'sm'; severity?: 'suggestive' | 'informative'; arrow?: never }
    | {
        size?: 'md';
        severity?:
          | 'informative'
          | 'suggestive'
          | 'success'
          | 'warning'
          | 'error';
        arrow?: never;
      }
    | {
        size?: 'md';
        severity?: 'informative' | 'success' | 'warning' | 'error';
        arrow?: never;
      }
    | {
        size?: 'md';
        severity: 'suggestive';
        arrow?: boolean;
      }
  );

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  {
    arrow = undefined,
    className,
    children,
    max,
    severity = 'informative',
    size = 'md',
    ...rest
  },
  ref
) {
  const valueInt = Number(String(children).trim()) || 0;
  const maxInt = Number(max === true ? 10 : max) || Infinity;
  if (valueInt > maxInt) children = `${maxInt}+`;
  return (
    <span
      className={clsx(styles.badge, styles[size], styles[severity], className)}
      ref={ref}
      {...rest}
    >
      {children}
      {arrow && (
        <svg
          width="17"
          height="9"
          viewBox="0 0 17 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.arrow}
        >
          <path d="M8.5 8L16 0.5L8.5 0.5L1 0.5L8.5 8Z" fill="#EEFF76" />
          <path d="M1 0.5H16" stroke="#EEFF76" />
          <path
            d="M0 0.5L0.956677 0.5C0.984318 0.5 1.01073 0.511442 1.02963 0.531607L8.42705 8.42218C8.46655 8.46432 8.53345 8.46432 8.57295 8.42218L15.9704 0.531606C15.9893 0.511441 16.0157 0.5 16.0433 0.5L17 0.5"
            stroke="#BAC3D9"
          />
        </svg>
      )}
    </span>
  );
});
